import React from 'react';
import { useNavigate } from 'react-router-dom';
import './ErrorScreen.css';

interface ErrorScreenProps {
  title: string;
  message: string;
  actionText?: string;
  onAction?: () => void;
}

const ErrorScreen: React.FC<ErrorScreenProps> = ({ 
  title, 
  message, 
  actionText = 'Go to Dashboard',
  onAction 
}) => {
  const navigate = useNavigate();

  const handleAction = () => {
    if (onAction) {
      onAction();
    } else {
      navigate('/dashboard');
    }
  };

  return (
    <div className="error-screen">
      <div className="error-container">
        <div className="error-icon">⚠️</div>
        <h1 className="error-title">{title}</h1>
        <p className="error-message">{message}</p>
        <button onClick={handleAction} className="error-button">
          {actionText}
        </button>
      </div>
    </div>
  );
};

export default ErrorScreen;

